import {
  WSButton,
  WSCard,
  WSElement,
  WSFlexBox,
  WSGrid,
  WSHorizontalScrollCards,
  WSLoader,
  WSScreen,
  WSText
} from "@wingspanhq/fe-component-library";
import { IMemberClient } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useHistory } from "react-router-dom";
import { useRecentMemberClientsQuery } from "../../../query/payments/queries";
import {
  getClientCompany,
  getClientEmail,
  getClientName
} from "../../../query/payments/selectors";

export const RecentClients: React.FC = () => {
  const history = useHistory();
  const queryRecentMemberClients = useRecentMemberClientsQuery();

  <WSElement my="3XL">
    <WSFlexBox.CenterY justify="space-between" mb="XL">
      <WSText.Heading5>Recent clients</WSText.Heading5>
      <WSButton.Link
        onClick={() => {
          history.push("/member/invoices/contacts/clients");
        }}
      >
        Manage clients
      </WSButton.Link>
    </WSFlexBox.CenterY>

    <RecentClients />
  </WSElement>;

  if (queryRecentMemberClients.isLoading) {
    return (
      <WSElement my="3XL">
        <WSText.Heading5>Recent clients</WSText.Heading5>
        <WSLoader.Spinner />
      </WSElement>
    );
  }

  const memberClients = queryRecentMemberClients.data || [];

  return (
    <WSElement my="3XL">
      <WSFlexBox.CenterY justify="space-between" mb="XL">
        <WSText.Heading5>Recent clients</WSText.Heading5>
        <WSButton.Link
          onClick={() => {
            history.push("/member/invoices/contacts/clients");
          }}
        >
          Manage clients
        </WSButton.Link>
      </WSFlexBox.CenterY>

      <WSScreen XS S>
        <WSHorizontalScrollCards>
          {memberClients.map(memberClient => (
            <Client
              key={memberClient.memberClientId}
              memberClient={memberClient}
            />
          ))}
        </WSHorizontalScrollCards>
      </WSScreen>
      <WSScreen M L XL>
        <WSGrid>
          {memberClients.map(memberClient => (
            <WSGrid.Item span={{ m: "3" }} key={memberClient.memberClientId}>
              <Client memberClient={memberClient} />
            </WSGrid.Item>
          ))}
        </WSGrid>
      </WSScreen>
    </WSElement>
  );
};

const Client: React.FC<{ memberClient: IMemberClient }> = ({
  memberClient
}) => {
  const history = useHistory();

  return (
    <WSCard
      style={{ height: "100%" }}
      title={getClientName(memberClient) || getClientEmail(memberClient)}
      content={getClientCompany(memberClient)}
      primaryAction={{
        label: "Create invoice",
        onClick: () => {
          history.push("/member/invoices/create", {
            backPath: "/member/invoices",
            memberClientId: memberClient.memberClientId
          });
        }
      }}
      headerLeft={{
        text:
          memberClient.name?.slice(0, 1) ||
          memberClient.company?.slice(0, 1) ||
          memberClient.emailTo?.slice(0, 1),
        color: "blue400",
        colorBackground: "blue50"
      }}
      size="S"
    />
  );
};
